import { useMutation, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { getActiveTenantId } from "@/shared/tenant/active-tenant";
import type { ConnectorDescriptor, MarketRankingResult } from "./types";

/** GET /api/connectors — the data-source picker's options + live availability (ADR-0019). */
export function useConnectors() {
  return useQuery({
    queryKey: ["connectors", getActiveTenantId()] as const,
    queryFn: () => httpClient<ConnectorDescriptor[]>("/api/connectors"),
  });
}

/** POST /api/markets/rank — rank cities/markets for a brief (AirDNA). */
export function useRankMarkets() {
  return useMutation({
    mutationFn: (input: { brief: string; limit?: number }) =>
      httpClient<MarketRankingResult>("/api/markets/rank", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(input),
      }),
  });
}
